import { CommonModule } from '@angular/common';
import {
  Component,
  computed,
  effect,
  input,
  output,
  signal,
} from '@angular/core';
import { Button } from '@shared/components/button/button';
import { Item } from '@shared/components/item/item';
import { Problem } from '@shared/models/problem';
@Component({
  selector: 'app-problem-modal',
  imports: [CommonModule, Button, Item],
  templateUrl: './problem-modal.html',
})
export class ProblemModal {
  readonly filterOption = signal<'all' | 'selected' | 'not_selected'>('all');
  readonly searchQuery = signal<string>('');
  showProblemModal = input<boolean>(false);
  problems = input<Problem[]>([]);
  closed = output<void>();
  AddProblem = output<Problem[]>();

  readonly currentSelectedProblems = signal<Problem[]>([]);
  readonly allProblems = signal<Problem[]>([]);
  tempSelectedIds = signal<Set<string>>(new Set());

  constructor() {
    effect(() => {
      if (this.problems()) {
        this.allProblems.set([...this.problems()]);
      }
    });
  }
  readonly filteredProblems = computed(() => {
    const query = this.searchQuery().toLowerCase();
    const selectedIds = this.tempSelectedIds();
    const filter = this.filterOption();

    return this.allProblems().filter(problem => {
      const matchesSearch =
        problem.title?.toLowerCase().includes(query) ||
        problem.description?.toLowerCase().includes(query) ||
        problem.duration?.toString().includes(query) ||
        problem.difficulty?.toLowerCase().includes(query);

      const isSelected = selectedIds.has(problem.problemId);

      if (filter === 'selected' && !isSelected) return false;
      if (filter === 'not_selected' && isSelected) return false;

      return matchesSearch;
    });
  });
  confirmSelection() {
    // Get only the newly selected problems for this modal session
    const selectedProblems = this.allProblems().filter(p =>
      this.tempSelectedIds().has(p.problemId)
    );

    // Only emit the newly selected problems, not accumulated ones
    this.AddProblem.emit(selectedProblems);

    // Clear temp selection for next time
    this.tempSelectedIds.set(new Set());

    // Close modal
    this.closed.emit();
  }

  toggleTempSelection(problemId: string) {
    const current = new Set(this.tempSelectedIds());
    if (current.has(problemId)) {
      current.delete(problemId);
    } else {
      current.add(problemId);
    }
    this.tempSelectedIds.set(current);
  }
}
